<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{$t('admin.views.faces.list_title')}}</h1>
    </div>
    <div class="content">
      <div>
        <div>
          <div>
            <div class="mb-30 action-panel flex items-center wrapper-x-40">
              <div
                class="action-panel-buttons"
                v-if="licensed"
              >
                <router-link
                  :to="{
                    name: 'add_face',
                    query: $route.query
                  }"
                  class="btn btn-small btn-green"
                >
                  <span><i class="fas fa-plus"></i></span>
                  <span class="ml-2">{{ $t('main.button_add') }}</span>
                </router-link>
                <button
                  class="btn btn-small btn-red"
                  @click="
                    $store.dispatch('faces/remove', deletes);
                    deletes = [];
                  "
                >
                  <span><i class="fas fa-times"></i></span>
                  <span class="ml-2">{{ $t('main.button_delete') }}</span>
                </button>
                <button
                  class="btn btn-small btn-default"
                  @click="
                    $store.dispatch('faces/block', { deletes, status: 0 });
                    deletes = [];
                  "
                >
                  <span><i class="fas fa-times"></i></span>
                  <span class="ml-2">{{ $t('main.button_block') }}</span>
                </button>
                <button
                  class="btn btn-small btn-default"
                  @click="
                    $store.dispatch('faces/block', { deletes, status: 1 });
                    deletes = [];
                  "
                >
                  <span><i class="fas fa-check"></i></span>
                  <span class="ml-2">{{ $t('main.button_unblock') }}</span>
                </button>
              </div>
            </div>

            <div
              class="element-list table-list-wrapper wrapper-x-40"
              v-if="faces"
            >
              <table>
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        @change="changeCheck"
                      />
                    </th>
                    <th class="image-name">{{ $t('main.tab_list') }}:</th>
                    <th class="status">{{ $t('main.column_status') }}:</th>
                    <th
                      class="axis"
                      v-html="$t('main.rotate_x')"
                    ></th>
                    <th
                      class="axis"
                      v-html="$t('main.rotate_y')"
                    ></th>
                    <th
                      class="axis"
                      v-html="$t('main.rotate_z')"
                    ></th>

                    <th class="axis">{{ $t('main.group') }}:</th>
                    <th class="id">ID:</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="face in faces"
                    :key="face.id"
                  >
                    <td>
                      <input
                        type="checkbox"
                        ref="checkDeletes"
                        :value="face.id"
                        v-model="deletes"
                      />
                    </td>
                    <td class="name">
                      <router-link :to="{
                          name: 'edit_face',
                          params: {
                            id: face.id,
                          },
                          query: $route.query
                        }">
                        {{ face.name }}
                      </router-link>
                    </td>
                    <td class="status">
                      <button
                        @click="$store.dispatch('faces/block', { deletes: [face.id], status: 0 })"
                        class="text-green-500"
                        :title="$t('main.active')"
                        v-if="face.status"
                      ><i class="fas fa-check"></i></button>
                      <button
                        @click="$store.dispatch('faces/block', { deletes: [face.id], status: 1 })"
                        class="text-red-500"
                        :title="$t('main.not_active')"
                        v-else
                      ><i class="fa fa-lock"></i></button>
                    </td>
                    <td class="axis_rotate">
                      {{ face.rotate_x }}
                    </td>
                    <td class="axis_angle">
                      {{ face.rotate_y }}
                    </td>
                    <td class="axis_slant">
                      {{ face.rotate_z }}
                    </td>
                    <td class="element_groups">
                      {{ face.element_groups.map(gr=>gr.name).join(', ') }}
                    </td>
                    <td class="id">{{ face.id }}</td>
                  </tr>
                </tbody>
              </table>
              <PaginationBar
                :meta="meta"
                :page="page"
                :per-page="per_page"
                :per-pages="perPages"
                @set-page="setPage"
                @set-per-page="setPerPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationBar from "../../../components/Admin/PaginationBar.vue";

export default {
  name: "List",
  components: { PaginationBar },
  data() {
    return {
      deletes: [],
      selectPerPage: this.$store.state.faces.per_page,
    };
  },
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
    faces() {
      return this.$store.state.faces.faces;
    },
    meta() {
      return this.$store.state.faces.meta;
    },
    page() {
      return this.$store.state.faces.page;
    },
    per_page() {
      return this.$store.state.faces.per_page;
    },
    perPages() {
      return this.$store.state.settings.perPages;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
  },
  mounted() {
    // if (this.settings && this.settings.per_page) {
    //   this.setPerPage(this.settings.per_page);
    // }
  },
  created() {
    this.receiveQuery();
  },
  methods: {
    receiveQuery() {
      if (Object.hasOwnProperty.call(this.$route.query, "perPage")) {
        this.$store.dispatch("faces/setPerPage", this.$route.query.perPage);
      }
      if (Object.hasOwnProperty.call(this.$route.query, "page")) {
        this.$store.dispatch("faces/setPage", this.$route.query.page);
      }
      this.$store.dispatch("faces/fetch");
    },

    setPage(page) {
      const query = {
        ...this.$route.query,
        page,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});

      //   this.$store.dispatch("faces/setPage", page);
    },

    setPerPage(perPage) {
      const query = {
        ...this.$route.query,
        perPage,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});
      //   this.$store.dispatch(
      //     "faces/setPerPage",
      //     event.target && event.target.value ? event.target.value : event
      //   );
    },

    changeCheck(event) {
      this.deletes = [];
      if (event.target.checked) {
        this.$refs.checkDeletes.map((check) => {
          check.checked = true;
          this.deletes.push(check.value);
        });
      } else {
        this.$refs.checkDeletes.map((check) => (check.checked = false));
      }
    },
  },
};
</script>
<style scoped>
.action-panel-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>
